export const appBrazeDashboardConfig = "/app/braze_dashboard_config";
